import React from 'react';
const initialState = {};
const themeStore = React.createContext(initialState);
const { Provider } = themeStore;

const ThemeProvider = (props) => {
	const { children } = props;
	const [ themeState, setThemeState ] = React.useState(false);
	React.useEffect(() => {
		const getTheme = localStorage.getItem('Theme');
		if (getTheme === 'dark') {
			setThemeState(true);
		}
	}, []);

	React.useEffect(
		() => {
			if (themeState) {
				localStorage.setItem('Theme', 'dark');
				document.body.classList.add('dark-mode');
			} else {
				localStorage.setItem('Theme', 'light');
				document.body.classList.remove('dark-mode');
			}
		},
		[ themeState ]
	);

	return (
		<Provider
			value={{
				setThemeState,
				themeState
			}}
		>
			{children}
		</Provider>
	);
};
export { themeStore, ThemeProvider };
